import { defineComponent as Oe, useAttrs as Ie, useSlots as Me, ref as c, computed as v, watch as U, nextTick as J, onMounted as Fe, onUnmounted as Re, createBlock as V, openBlock as r, mergeProps as $e, unref as y, createSlots as Pe, withCtx as k, createElementVNode as d, toDisplayString as _, withDirectives as M, createElementBlock as f, Fragment as K, renderList as G, withKeys as re, normalizeClass as F, createCommentVNode as R, renderSlot as q, createTextVNode as $, withModifiers as P, createVNode as S, Teleport as ze, Transition as He, normalizeStyle as Ne, vModelText as Ae, vShow as Q } from "vue";
import { u as De, a as Le, f as Ue, o as Ve, s as Ke } from "./floating-ui.vue-pzUuloyX.js";
import Ge from "@leaflink/snitch";
import qe from "lodash-es/debounce";
import je from "lodash-es/isEmpty";
import ie from "lodash-es/isEqual";
import We from "lodash-es/isPlainObject";
import Xe from "lodash-es/uniqueId";
import Ye from "./useSearch.js";
import { DEBOUNCE as Je, KEY_CODES as E } from "./constants.js";
import Qe from "./directives/clickoutside.js";
import { D as Ze } from "./MenusPlugin-Bk6UW6o9.js";
import ce from "./Chip.js";
import z from "./Icon.js";
import { _ as et } from "./Field.vue_vue_type_script_setup_true_lang-DRaKs9Lm.js";
import { _ as tt } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const lt = { class: "tw-flex tw-h-input tw-items-center tw-text-sm" }, at = ["id", "aria-labelledby"], st = ["id", "aria-errormessage", "aria-invalid", "disabled", "multiple", "name"], nt = ["selected", "value", "disabled"], ot = ["aria-controls", "aria-expanded", "aria-label", "aria-disabled"], rt = ["id"], it = ["onKeypress", "onMousedown"], ct = {
  key: 0,
  class: "stash-select__total"
}, ut = {
  key: 0,
  class: "tw-flex tw-items-center tw-border-b tw-border-blue-500 tw-pr-1.5"
}, dt = ["data-test", "placeholder"], ft = { class: "stash-select__options options tw-my-1.5 tw-w-full tw-border-white tw-bg-white" }, pt = ["data-test", "onClick", "onMouseenter"], vt = { class: "tw-m-1.5 tw-cursor-default tw-p-1.5" }, ht = {
  class: "tw-m-1.5 tw-cursor-default tw-p-1.5",
  "data-test": "stash-select|no-options"
}, mt = /* @__PURE__ */ Oe({
  name: "ll-select",
  __name: "Select",
  props: {
    preventEmpty: { type: Boolean, default: !1 },
    allowEmpty: { type: [String, Boolean, null], default: null },
    displayBy: { default: "name" },
    searchBy: { default: () => [] },
    trackBy: { default: "id" },
    placeholder: { default: "Select option" },
    error: { default: "" },
    hint: { default: "" },
    icon: { type: [String, Boolean], default: "caret-down" },
    name: { default: void 0 },
    options: { default: () => [] },
    lazy: { type: Function, default: void 0 },
    modelValue: { default: () => [] },
    value: { default: null },
    hideSearch: { type: Boolean, default: !1 },
    searchable: { type: [String, Boolean, null], default: null },
    preserveSearchTerm: { type: Boolean, default: !1 },
    disableFiltering: { type: Boolean, default: !1 },
    single: { type: Boolean, default: !1 },
    noTruncate: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    searchLoading: { type: Boolean, default: !1 },
    selectItemType: { default: "" },
    hideCheck: { type: Boolean, default: !1 },
    searchPlaceholder: { default: "Search" },
    onSearch: { type: Function, default: void 0 },
    useFuzzySearch: { type: Boolean, default: !1 },
    menuPlacement: { default: "bottom-start" },
    enableTeleport: { type: Boolean, default: !1 },
    teleportTo: { default: `#${Ze}` },
    addBottomSpace: { type: Boolean },
    errorText: {},
    hintText: {},
    id: {},
    errorId: {},
    isReadOnly: { type: Boolean },
    isRequired: { type: Boolean },
    label: {},
    showOptionalInLabel: { type: Boolean },
    fieldset: { type: Boolean },
    isDisabled: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:model-value", "clear", "add", "remove", "opened", "closed"],
  setup(ue, { emit: de }) {
    const t = ue, h = de, H = Ie(), fe = Me(), Z = c(null), m = c(null), x = c(null), j = c(null), ee = c(null), N = c(0), T = c(0), n = c([]), te = c(() => []), w = c(""), p = c(-1), u = c(!1), W = c({}), le = c(!1), { floatingStyles: pe } = De(Z, x, {
      whileElementsMounted: Le,
      placement: t.menuPlacement,
      middleware: [
        Ue(),
        Ve(({ rects: e, placement: l }) => l.split("-")[0] === "bottom" && N.value > T.value ? N.value - e.reference.height + 6 : 6),
        Ke({
          apply({ availableHeight: e, elements: l, rects: s }) {
            t.enableTeleport && Object.assign(l.floating.style, {
              maxWidth: `${s.reference.width}px`,
              maxHeight: `${Math.min(e, 300)}px`
            });
          }
        })
      ]
    }), X = v(() => !t.hideSearch && t.searchable !== "false" && t.searchable !== !1), A = v(() => {
      let e = (le.value && t.lazy ? t.lazy() : t.options).filter(Boolean);
      return We(e[0]) || (e = e.map((l, s) => ({ name: l, id: s }))), e;
    }), ve = v(() => n.value.length ? n.value.map((e) => e[t.displayBy] || e).join(", ") : ""), ae = v(() => t.searchLoading || Object.keys(W.value).length > 0), C = v(() => t.disableFiltering || !(w.value || "").trim() ? A.value : te.value(w.value)), he = v(() => N.value <= T.value), me = v(
      () => !u.value && !t.single && !he.value && n.value.length
    ), ye = v(() => [n.value.length, t.selectItemType, "selected"].filter(Boolean).join(" ")), we = v(() => t.preventEmpty || t.allowEmpty === "false" || t.allowEmpty === !1);
    U(w, (e, l) => l !== e && L(-1)), U(n, () => I(), { deep: !0 }), U(
      () => t.modelValue,
      (e) => {
        if (Array.isArray(e)) {
          const l = e.filter(Boolean);
          ie(l, n.value) || (n.value = l);
          return;
        }
        if (!je(e)) {
          ie(e, n.value[0]) || (n.value[0] = e);
          return;
        }
        n.value = [];
      },
      { immediate: !0 }
    ), U(
      () => t.options,
      () => {
        const { searchFor: e } = Ye({
          items: v(() => A.value),
          fieldNames: t.searchBy.length ? t.searchBy : [t.displayBy],
          trackBy: t.trackBy
        });
        te.value = (l) => e(l, { fuzzy: t.useFuzzySearch });
      },
      { immediate: !0 }
    );
    const Y = (e) => e && typeof e == "object" && "disabled" in e && (e == null ? void 0 : e.disabled), ge = () => {
      n.value = [], h("update:model-value", t.single ? void 0 : n.value), h("clear");
    }, D = (e) => {
      t.disabled || !e || Y(e) || (B(e) ? O(e) : (t.single && (n.value = []), n.value.push(e), h("update:model-value", t.single ? n.value[0] : n.value), h("add", e)), t.single && b());
    }, _e = (e) => {
      if (t.single) {
        const s = A.value.find((o) => {
          var i;
          return ((i = o[t.trackBy]) == null ? void 0 : i.toString()) === e.target.value;
        });
        D(s);
        return;
      }
      const l = [...e.target.selectedOptions];
      for (const s of [...n.value])
        l.find((i) => {
          var a;
          return i.value === ((a = s[t.trackBy]) == null ? void 0 : a.toString());
        }) || O(s);
      for (const s of l) {
        const o = A.value.find(
          (i) => {
            var a;
            return ((a = i[t.trackBy]) == null ? void 0 : a.toString()) === s.value;
          }
        );
        B(o) || D(o);
      }
    }, O = (e) => {
      if (t.disabled || we.value && n.value.length === 1)
        return;
      const l = n.value.findIndex((s) => s[t.trackBy] === e[t.trackBy]);
      if (l === -1) {
        Ge.warn("ll-select: could not find option to remove", e);
        return;
      }
      n.value.splice(l, 1), h("update:model-value", t.single ? n.value[0] : n.value), h("remove", e, l);
    }, se = () => {
      u.value || (I(), u.value = !0, h("opened"), X.value && J(() => {
        var e;
        (e = ee.value) == null || e.focus({ preventScroll: !0 });
      }));
    }, b = () => {
      var e;
      u.value && h("closed", n.value), L(-1), u.value = !1, t.preserveSearchTerm || (w.value = ""), (e = m.value) == null || e.blur();
    }, be = async (e) => {
      if (await J(), !m.value)
        return;
      if (![E.ENTER, E.ESCAPE].includes(e.keyCode)) {
        const s = m.value.querySelector(".stash-select__option--highlighted"), o = s == null ? void 0 : s.getBoundingClientRect(), i = m.value.getBoundingClientRect();
        if (!o || !i)
          return;
        (o.bottom >= i.bottom || o.top <= i.top + o.height) && (s == null || s.scrollIntoView({ block: "nearest", inline: "nearest" }));
      }
    }, L = (e) => {
      p.value = e;
    }, Be = (e) => {
      if (e.keyCode === E.ESCAPE)
        b();
      else if (e.keyCode === E.DOWN && p.value < C.value.length - 1 && u.value)
        p.value++;
      else if (e.keyCode === E.UP && p.value > 0)
        u.value && p.value--, x.value && X.value && p.value === 0 && (x.value.scrollTop -= 100);
      else if (e.keyCode === E.ENTER && p.value !== -1 && u.value)
        D(C.value[p.value]);
      else
        return;
      e.preventDefault(), be(e);
    }, ne = qe(function() {
      ke();
    }, Je.FAST), ke = async function() {
      if (!t.onSearch)
        return;
      const e = Xe("search-request-");
      try {
        W.value[e] = !0, await t.onSearch(w.value);
      } finally {
        delete W.value[e];
      }
    }, Se = (e, l) => [
      {
        "stash-select__option": !0,
        "stash-select__option--disabled": Y(e),
        "stash-select__option--highlighted": p.value === l,
        "stash-select__option--selected": B(e)
      },
      // @deprecated
      // backwards compatibility
      {
        "is-selected": p.value === l,
        "tw-bg-ice-200": p.value === l,
        "tw-bg-blue-100 tw-text-ice-700": B(e)
      }
    ], B = (e) => e == null ? !1 : n.value.some((l) => (l == null ? void 0 : l[t.trackBy]) === e[t.trackBy]);
    function oe(e) {
      var o, i;
      if (!e)
        return !1;
      const l = (o = m.value) == null ? void 0 : o.contains(e), s = (i = x.value) == null ? void 0 : i.contains(e);
      return l || s;
    }
    function Ee(e) {
      const l = e.relatedTarget;
      !oe(l) && l && b();
    }
    function xe(e) {
      const l = e.target;
      oe(l) || b();
    }
    const Te = () => {
      L(-1);
    }, I = async () => {
      await J(), j.value && m.value && (T.value = T.value === 0 ? m.value.clientHeight : T.value, N.value = j.value.clientHeight);
    };
    return Fe(() => {
      if (H.onInput)
        throw new Error("ll-select: use the @update:model-value event instead of @input.");
      window.addEventListener("resize", I), I();
    }), Re(() => {
      window.removeEventListener("resize", I);
    }), (e, l) => (r(), V(et, $e(t, {
      class: ["input ll-select stash-select", y(H).class],
      "data-test": "stash-select",
      "error-text": t.errorText || t.error,
      "hint-text": t.hintText || t.hint
    }), Pe({ _: 2 }, [
      t.isReadOnly ? {
        name: "default",
        fn: k(({ fieldId: s, labelId: o }) => [
          d("div", lt, [
            d("span", {
              id: s,
              "aria-labelledby": o,
              class: "show-empty tw-h-min"
            }, _(ve.value), 9, at)
          ])
        ]),
        key: "0"
      } : {
        name: "default",
        fn: k(({ fieldId: s, fieldErrorId: o, hasError: i }) => [
          d("select", {
            id: s,
            "aria-errormessage": o,
            "aria-invalid": i,
            class: "tw-sr-only",
            disabled: t.disabled,
            multiple: !t.single,
            name: t.name,
            onChange: _e
          }, [
            (r(!0), f(K, null, G(C.value, (a, g) => (r(), f("option", {
              key: `srOnlyOption-${g}`,
              selected: B(a),
              value: a[t.trackBy],
              disabled: Y(a)
            }, _(a[t.displayBy] || ""), 9, nt))), 128)),
            l[5] || (l[5] = d("option", { value: "" }, null, -1))
          ], 40, st),
          M((r(), f("div", {
            ref_key: "selectRef",
            ref: Z,
            role: "listbox",
            "aria-hidden": "true",
            class: F(["stash-select__content-wrapper", [
              {
                "stash-select--disabled": !!t.disabled,
                "stash-select--error": !!(t.errorText || t.error),
                "stash-select--active": u.value,
                "stash-select--single": t.single
              },
              // @deprecated
              // backwards compatibility
              {
                "is-active": u.value,
                "is-single": t.single,
                "is-disabled": t.disabled
              }
            ]]),
            "aria-controls": "listbox-" + s,
            "aria-expanded": u.value,
            "aria-label": t.placeholder,
            "aria-disabled": t.disabled || void 0,
            onKeydown: Be,
            onKeyup: re(b, ["esc"])
          }, [
            d("div", {
              id: "listbox-" + s,
              ref_key: "contentRef",
              ref: m,
              class: "input-field stash-select__content",
              tabindex: "0",
              "data-test": "stash-select|dropdown-trigger",
              onFocusin: se,
              onFocusinOnce: l[4] || (l[4] = (a) => le.value = !0),
              onFocusout: Ee,
              onKeydown: se,
              onMouseleave: Te
            }, [
              d("ul", {
                ref_key: "chipsRef",
                ref: j,
                class: "stash-select__chips"
              }, [
                n.value.length ? R("", !0) : (r(), f("li", {
                  key: 0,
                  class: F(["stash-select__placeholder tw-mr-0 tw-pl-1.5", { "tw-truncate": !t.noTruncate }])
                }, _(t.placeholder), 3)),
                t.single ? (r(!0), f(K, { key: 1 }, G(n.value, (a) => (r(), f("li", {
                  key: `chip-${a[t.trackBy]}`,
                  class: F(["stash-select__selected tw-mr-0 tw-pl-1.5", { "tw-truncate": !t.noTruncate }])
                }, [
                  q(e.$slots, "selected", { option: a }, () => [
                    $(_(a[t.displayBy] || a) + " ", 1),
                    d("button", {
                      tabindex: "-1",
                      class: "stash-select__remove",
                      onKeypress: re(P((g) => O(a), ["prevent"]), ["enter"]),
                      onMousedown: P((g) => O(a), ["prevent", "stop"])
                    }, [
                      S(z, {
                        icon: "close",
                        name: "close",
                        size: "small"
                      })
                    ], 40, it)
                  ], !0)
                ], 2))), 128)) : (r(!0), f(K, { key: 2 }, G(n.value, (a) => (r(), f("li", {
                  key: `chip-${a[t.trackBy]}`,
                  class: "tw-inline-block"
                }, [
                  S(ce, {
                    "bg-color": "blue-500",
                    "is-removable": "",
                    "text-color": "white",
                    class: "stash-select__chip",
                    onRemove: (g) => O(a)
                  }, {
                    default: k(() => [
                      $(_(a[t.displayBy] || a), 1)
                    ]),
                    _: 2
                  }, 1032, ["onRemove"])
                ]))), 128))
              ], 512),
              me.value ? (r(), f("div", ct, [
                S(ce, {
                  "bg-color": "blue-500",
                  "is-removable": "",
                  "text-color": "white",
                  class: "stash-select__chip",
                  onRemove: ge
                }, {
                  default: k(() => [
                    $(_(ye.value), 1)
                  ]),
                  _: 1
                })
              ])) : R("", !0),
              t.icon ? (r(), V(z, {
                key: 1,
                class: F(["stash-select__icon", { "tw-text-ice-500": t.disabled }]),
                "data-test": "stash-select|toggle-icon",
                name: t.icon,
                onMousedown: l[0] || (l[0] = P((a) => u.value && b(), ["prevent"]))
              }, null, 8, ["name", "class"])) : R("", !0),
              (r(), V(ze, {
                to: t.teleportTo,
                disabled: !t.enableTeleport
              }, [
                S(He, { name: "fade" }, {
                  default: k(() => [
                    M(d("div", {
                      ref_key: "optionsWrapperRef",
                      ref: x,
                      class: "stash-select__border-selector tw-w-full tw-shadow-2xl",
                      style: Ne(y(pe)),
                      onClick: l[3] || (l[3] = P(() => {
                      }, ["stop"]))
                    }, [
                      X.value ? (r(), f("div", ut, [
                        M(d("input", {
                          ref_key: "searchRef",
                          ref: ee,
                          "onUpdate:modelValue": l[1] || (l[1] = (a) => w.value = a),
                          type: "text",
                          autocomplete: "off",
                          class: "stash-select__search",
                          "data-test": y(H)["data-test"] ? y(H)["data-test"] + "-search" : "stash-select|search",
                          placeholder: t.searchPlaceholder,
                          spellcheck: !1,
                          onInput: l[2] || (l[2] = //@ts-ignore
                          (...a) => y(ne) && y(ne)(...a))
                        }, null, 40, dt), [
                          [Ae, w.value]
                        ]),
                        S(z, {
                          name: "search",
                          class: "tw-text-ice-500"
                        })
                      ])) : R("", !0),
                      d("ul", ft, [
                        (r(!0), f(K, null, G(C.value, (a, g) => (r(), f("li", {
                          key: `option-${a[t.trackBy]}`,
                          "data-test": a[t.trackBy],
                          class: F(Se(a, g)),
                          onClick: (Ce) => D(a),
                          onMouseenter: P((Ce) => L(g), ["self"])
                        }, [
                          q(e.$slots, "option", { option: a }, () => [
                            $(_(a[t.displayBy] || a), 1)
                          ], !0),
                          B(a) && !t.hideCheck ? (r(), V(z, {
                            key: 0,
                            class: "tw-ml-auto tw-text-blue-500",
                            name: "check"
                          })) : R("", !0)
                        ], 42, pt))), 128)),
                        M(d("li", vt, [
                          S(z, {
                            "data-test": "stash-select|options-loading",
                            name: "working",
                            class: "tw-animate-spin tw-text-ice-500"
                          })
                        ], 512), [
                          [Q, t.loading || ae.value]
                        ]),
                        M(d("li", ht, [
                          q(e.$slots, "no-options", {}, () => [
                            l[6] || (l[6] = $(" No options "))
                          ], !0)
                        ], 512), [
                          [Q, !t.loading && !ae.value && !C.value.length]
                        ])
                      ])
                    ], 4), [
                      [Q, u.value && !t.disabled]
                    ])
                  ]),
                  _: 3
                })
              ], 8, ["to", "disabled"]))
            ], 40, rt)
          ], 42, ot)), [
            [y(Qe), xe]
          ])
        ]),
        key: "1"
      },
      y(fe).hint ? {
        name: "hint",
        fn: k(() => [
          q(e.$slots, "hint", {}, void 0, !0)
        ]),
        key: "2"
      } : void 0
    ]), 1040, ["class", "error-text", "hint-text"]));
  }
}), Pt = /* @__PURE__ */ tt(mt, [["__scopeId", "data-v-f49a04ce"]]);
export {
  Pt as default
};
//# sourceMappingURL=Select.js.map
